import { compose, setDisplayName, pure, lifecycle } from 'recompose';
import { createSelector } from 'reselect';
import { connect } from 'react-redux';

import MenuWeekly from '../../views/Menu/MenuWeekly';
import {
  selectMenus,
  selectAllergensUrl,
  selectWellnessMenuUrl
} from '../../../selectors';
import { loadWeeklyMenu } from '../../../actions';

const enhance = compose(
  setDisplayName('MenuWeeklyContainer'),
  connect(
    createSelector(
      selectMenus(),
      selectAllergensUrl(),
      selectWellnessMenuUrl(),
      (menus, allergensUrl, wellnessMenuUrl) => ({
        menus,
        allergensUrl,
        wellnessMenuUrl
      })
    ),
    {
      loadWeeklyMenu
    }
  ),
  lifecycle({
    componentDidMount() {
      this.props.loadWeeklyMenu();
    }
  }),
  pure
)(MenuWeekly);

export default enhance;
